import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { BsModalService } from 'ngx-bootstrap/modal';
import { map } from 'rxjs/operators';
import { AppointmentLogComponent } from '../../appointment-log/appointment-log.component';
import { AppointmentListActions } from './appointment-list.actions';

@Injectable()
export class AppointmentListEffects {
    constructor(
        private actions$: Actions,
        private modalService: BsModalService) {
    }

    openAppointmentLogsFromLogsJS$ = createEffect(() =>
            this.actions$
                .pipe(
                    ofType(AppointmentListActions.openAppointmentLogsFromLogsJS),
                    map(({appointment, dialogType , selectedMessage, userTimeZone, userPermissionKeys}) => {
                        this.modalService
                            .show(AppointmentLogComponent,
                                {
                                    initialState: {
                                        appointment, type: dialogType , selectedMessage, userTimeZone, userPermissionKeys
                                    },
                                    backdrop: 'static',
                                    class: 'modal-lg-preview'

                                });
                    })),
        {dispatch: false}
    );

    openAppointmentLogsFromAppointmentList$ = createEffect(() =>
            this.actions$
                .pipe(
                    ofType(AppointmentListActions.openAppointmentLogsFromAppointmentList),
                    map(({appointment, dialogType , selectedMessage, userTimeZone, userPermissionKeys}) => {
                        this.modalService
                            .show(AppointmentLogComponent,
                                {
                                    initialState: {
                                        appointment, type: dialogType , selectedMessage, userTimeZone, userPermissionKeys
                                    },
                                    backdrop: 'static',
                                    class: 'modal-lg-preview'

                                });
                    })),
        {dispatch: false}
    );
}
